import { createContext, useContext, useState } from "react";
import { NEUTRAL_ADJ } from "@/data/cinema";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  // الصورة المشتركة بين الصفحات (Data URL)
  const [sharedImage, setSharedImage] = useState(null);
  // الفلتر النشط للكاميرا / التطبيق
  const [activeFilterId, setActiveFilterId] = useState(null);
  // القالب المطبّق على الكاميرا
  const [activeTemplateId, setActiveTemplateId] = useState(null);
  // تعديلات الفلتر الحالية
  const [adjustments, setAdjustments] = useState(NEUTRAL_ADJ);
  // آخر نتيجة تحليل
  const [lastResult, setLastResult] = useState(null);
  // وضع العرض الأفقي 16:9 (يدعم ?present=1 للفتح المباشر على شاشات العرض)
  const [presentation, setPresentation] = useState(() => {
    try {
      if (typeof window !== "undefined" && window.location.search.includes("present=1")) return true;
      return localStorage.getItem("cineart_presentation") === "1";
    } catch (e) { return false; }
  });
  const togglePresentation = () =>
    setPresentation((p) => {
      const nv = !p;
      try { localStorage.setItem("cineart_presentation", nv ? "1" : "0"); } catch (e) {}
      return nv;
    });

  // معرض الجلسة لـ CineVision (في الذاكرة فقط — يُمسح عند إغلاق/تحديث التطبيق)
  const [cvGallery, setCvGallery] = useState([]);
  const addToGallery = (item) =>
    setCvGallery((g) => [{ ...item, id: `g-${Date.now()}-${Math.random().toString(36).slice(2, 6)}` }, ...g]);
  const removeFromGallery = (id) => setCvGallery((g) => g.filter((x) => x.id !== id));

  return (
    <AppContext.Provider
      value={{
        sharedImage, setSharedImage,
        activeFilterId, setActiveFilterId,
        activeTemplateId, setActiveTemplateId,
        adjustments, setAdjustments,
        lastResult, setLastResult,
        presentation, togglePresentation,
        cvGallery, addToGallery, removeFromGallery,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
